module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/hall-list/plan-wedding-lineup-kyushu-3-4920e03635782f36386dcf9dde26191c.jpg";